import { Text, VStack } from '@chakra-ui/react';
import { TContent } from '@/types/Content.types';

const TitleBlock = ({ content }: { content: TContent }) => (
  <VStack align="stretch" gap="10px">
    <Text
      fontFamily="Lora"
      fontStyle="italic"
      fontWeight={600}
      fontSize={{ base: '24px', md: '30px' }}
      color="text.darkBlue"
      lineHeight="1.25"
    >
      {content.title || 'Untitled'}
    </Text>
    {content.description && (
      <Text fontSize="15px" color="text.mediumBlue" lineHeight="22px">
        {content.description}
      </Text>
    )}
  </VStack>
);

export default TitleBlock;
